import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {HomePageComponent} from './components/home-page/home-page.component';
import {AuthGuard} from 'common-domain';
import {RequestDetailsComponent} from './components/request-details/request-details.component';
import {PATH_CONSTANTS} from '../app-routing.module';
import {AuthorizeRequestComponent} from './components/authorize-request/authorize-request.component';
import {AllDomainsListViewComponent} from './components/home-page/all-domains-list-view/all-domains-list-view.component';
import {UserSettingsComponent} from 'common-domain';

export const USER_PATH_CONSTANTS = {
  USER_HOME: 'home',
  USER_SETTINGS: 'settings',
  ALL_DOMAINS: 'domains',
  REQUEST_DETAILS: 'request-details/' ,
  AUTHORIZE_REQUEST: 'authorize/'
};

const routes: Routes = [
  {
    path: '',
    redirectTo: '/user/home',
    pathMatch: 'full'
  },
  {
    path: USER_PATH_CONSTANTS.USER_HOME,
    component: HomePageComponent,
    canActivate: [AuthGuard]
  }, {
    path: USER_PATH_CONSTANTS.REQUEST_DETAILS + ':requestNumber',
    component: RequestDetailsComponent,
    canActivate: [AuthGuard]
  }, {
    path: USER_PATH_CONSTANTS.AUTHORIZE_REQUEST + ':requestNumber',
    component: AuthorizeRequestComponent,
    canActivate: [AuthGuard]
  }, {
    path: USER_PATH_CONSTANTS.USER_SETTINGS,
    component: UserSettingsComponent,
    canActivate: [AuthGuard]
  }, {
    path: USER_PATH_CONSTANTS.ALL_DOMAINS,
    component: AllDomainsListViewComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule {

}
